window.addEventListener('load', function() {
  $('nav.secondary-nav ul.nav').each(function() {
    $(this)
      .children('li')
      .click(function() {
        $(this)
          .parent()
          .children('li')
          .removeClass('active');

        $(this).addClass('active');
      });
  });
});
